import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { ReactComponent as CalendarSVG } from "go-core/images/svg/calendar.svg";
import { KSeFInvoiceApi } from "../../../../../../../../services/Api/Organization/types";

interface Props {
	ksefData: KSeFInvoiceApi;
}

export const KSeFInfoCard = ({ ksefData }: Props) => {
	const { t } = useTranslation();
	const { created_at } = ksefData;

	return (
		<Card>
			<h5 className="card-header">{t("modules.invoice.header.ksef_info.title")}</h5>
			<Card.Body>
				<div className="row">
					<div className="col-md-3 card-body-item">
						<CalendarSVG />
						<div className="item-info">
							<span className="label">{t("lib:common.action.created_at")}</span>
							<span>{FormatDate(created_at)}</span>
						</div>
					</div>
					<div className="col-md-3 card-body-item">
						<CalendarSVG />
						<div className="item-info">
							<span className="label">{t("lib:common.action.created_at")}</span>
							<span>{FormatDate(created_at)}</span>
						</div>
					</div>
					<div className="col-md-3 card-body-item">
						{" "}
						<CalendarSVG />
						<div className="item-info">
							<span className="label">{t("lib:common.action.created_at")}</span>
							<span>{FormatDate(created_at)}</span>
						</div>
					</div>
					<div className="col-md-3 card-body-item">
						{" "}
						<CalendarSVG />
						<div className="item-info">
							<span className="label">{t("lib:common.action.created_at")}</span>
							<span>{FormatDate(created_at)}</span>
						</div>
					</div>
				</div>
			</Card.Body>
		</Card>
	);
};
